import { render } from "./STERiGLIDE.vue?vue&type=template&id=2d98223d&scoped=true"
import script from "./STERiGLIDE.vue?vue&type=script&lang=js"
export * from "./STERiGLIDE.vue?vue&type=script&lang=js"

import "./STERiGLIDE.vue?vue&type=style&index=0&id=2d98223d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d98223d"]])

export default __exports__